import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateNodesFromDOM } from "@lexical/html";

export default function EditorInitializer({ html }) {
	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		if (!html) return;

		editor.update(() => {
			const parser = new DOMParser();
			const dom = parser.parseFromString(html, "text/html");
			const nodes = $generateNodesFromDOM(editor, dom);

			const root = editor.getRootElement();
			if (root) {
				const rootNode = editor._editorState._nodeMap.get("root");
				if (rootNode) {
					rootNode.clear();
					rootNode.append(...nodes);
				}
			}
		});

		// 👇 run only once on mount
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
}
